import { render, staticRenderFns } from "./ThePageTitle.vue?vue&type=template&id=71ef6ea5&scoped=true"
import script from "./ThePageTitle.vue?vue&type=script&lang=ts"
export * from "./ThePageTitle.vue?vue&type=script&lang=ts"
import style0 from "./ThePageTitle.vue?vue&type=style&index=0&id=71ef6ea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef6ea5",
  null
  
)

export default component.exports